// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TE22","option":"styles_option__12uia","active":"styles_active__1qBEg"};